import { GlobalController } from 'src/shared/global/GlobalController'
import Campaign from './Campaign.vue'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'campaign',
    component: Campaign,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
